import { Component, NgZone, ViewChild, ElementRef } from '@angular/core';

import { NavController, ModalController, NavParams, MenuController} from 'ionic-angular';

import { UserData } from '../../providers/user-data';
import { ToastController } from 'ionic-angular';

import moment from 'moment';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import { File } from '@ionic-native/file';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

//import { Camera, CameraOptions } from '@ionic-native/camera';
import { Http } from '@angular/http';

import { CommonData } from '../../providers/common-data';
import { KontrollenData } from './kontrollen-data';
import { ParkbewilligungenData, PbKategorieTyp } from '../parkbewilligungen/parkbewilligungen-data';
import { PPListPage } from '../pp-list/pp-list';
import { UECreatePage } from '../ue/ue-create';
import { AlertController } from 'ionic-angular';
import { AccountHomePage } from '../account/account-home';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { PhotoLibrary } from '@ionic-native/photo-library';
import { Platform } from 'ionic-angular';
import { normalizeURL} from 'ionic-angular';
//import * as EXIF from '../../assets/js/exif'
import { Events } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { LPPBRecognizerComponent } from "../../components/lppbrecognizer/lppbrecognizer"
import { PbcheckresultComponent } from "../../components/pbcheckresult/pbcheckresult";

import { Vibration } from '@ionic-native/vibration';

declare var cordova : any;
declare var FileTransfer : any;
declare var HTMLImageElement : any;
declare var navigator : any;
declare var device : any;
declare var CordovaExif : any;
@Component({
  selector: 'kontrollen-create',
  templateUrl: 'kontrollen-create.html'
})
export class KontrollenCreatePage {
  public PbKategorieTyp = PbKategorieTyp;  
  @ViewChild('fileInput') fileElement: ElementRef;
  @ViewChild(LPPBRecognizerComponent) lppbRecognizer: LPPBRecognizerComponent;  
  sNormalColor = "primary";
  sCheckedColor = "secondary";

  sPressedButton = "";

  debug = "";

  //sBtnBeweisColor = this.sNormalColor;

  sBtnKontrBeweis;  
  sBtnFalschparker;  
  sBtnKontrFinish;  
  actlat : number;
  actlng : number;
  bUploading:boolean;
  oSelectedPP;
  strTmp: string;
  bKontStarted:boolean;
  zone: NgZone;
  pbid:string;
  pbResults:any;
  bShowPbDetail:boolean;
  aWebBeweise;

  bManualDate: boolean;
  sDateTimeBeweis;

  errorinterval:any
  
  constructor(
              private navParams: NavParams
            , public navCtrl: NavController
            , public userData: UserData
            , public toastCtrl: ToastController
            , public common: CommonData
            , public http: Http
            , public modalCtrl: ModalController
            , public kontrollenData: KontrollenData 
            , public alertCtrl: AlertController
           , public camera: Camera
            , public platform:Platform
            , public file: File
            , public domSanitizer: DomSanitizer
            , public photoLibrary: PhotoLibrary
            , private menu: MenuController
            , private events: Events
            , private barcodeScanner: BarcodeScanner
            , private pbData : ParkbewilligungenData
            , private iab: InAppBrowser
            , private vibration: Vibration
            ) {
    //let selectedpp = navParams.get('pp');
    this.zone = new NgZone({ enableLongStackTrace: false });
    this.pbid = "";
    this.bShowPbDetail = false;
    this.bManualDate = false;
    this.aWebBeweise = [];
    this.events.subscribe('updateScreen', () => {
      this.zone.run(() => {
        console.log('force update the screen');
      });
    });
    this.errorinterval = null;

    this.bUploading = false;
    this.bKontStarted = true; 
    this.kontrollenData.actkontrolleuecount = 0;
    
    this.oSelectedPP = navParams.data.pp;
    
    //Button Texte 
    let iStepNo = 1;
    if(this.oSelectedPP.kontrollprozess == 1){
      this.sBtnKontrBeweis = iStepNo + ". Kontrollbeweise erfassen";
      iStepNo++;  
    }   
    this.sBtnFalschparker = iStepNo + ". Falschparker erfassen";  
    iStepNo++;
    this.sBtnKontrFinish = iStepNo + ". Kontrolle abschliessen";  


    this.actlat = navParams.data.actlat;
    this.actlng = navParams.data.actlng;
    
    this.kontrollenData.createKont(this.oSelectedPP.grundid, this.actlng, this.actlat)
    .then(result => {
      if(result == false){
        let error = 'Fehler beim erzeugen der Kontrolle';
        if(this.kontrollenData.kont.error){
          error = 'PP gesperrt, Grund:'+this.kontrollenData.kont.error;
        }
          let toast = this.toastCtrl.create({
            message: error,
            dismissOnPageChange: true,
            duration: 4000,
            position: 'middle',
            cssClass: 'warning',
            closeButtonText: 'schliessen',
            showCloseButton: true
          });
          toast.onDidDismiss(() => {
            if(this.errorinterval){
              clearInterval(this.errorinterval);
            }
            this.navCtrl.setRoot(AccountHomePage);            
          });          
          toast.present();
          this.errorinterval = setInterval(() => {
           if (this.errorinterval) {
              clearInterval(this.errorinterval);
           }            
            this.navCtrl.setRoot(AccountHomePage);
          }, 4000);
          /*
          .then(data =>{
            this.navCtrl.setRoot(AccountHomePage);
          })
          */        
      }
      else{

      }
    });
    
   }


  openMenu(evt) {
    if(this.menu.isOpen('pbmenu')){
      this.menu.enable(true, 'loggedInMenu');
      this.menu.enable(false, 'pbmenu');
      this.menu.close();  
    }
    else{
      this.menu.enable(false, 'loggedInMenu');
      this.menu.enable(true, 'pbmenu');
      this.menu.open();        
    }
    /*
    if(evt === "pbmenu"){
       this.menu.enable(true, 'pbmenu');

    }else{
       this.menu.enable(true, 'pbmenu');
    }
    this.menu.toggle();
    */    
} 
onPlateRecognized(event){
  this.checkPlate(event.plate);
}  

onFalschparkerErfassen(event){
  this.navCtrl.push(UECreatePage, {pp: this.oSelectedPP, fkkontrolle:this.kontrollenData.kont.kontid, plate: event.plate, uselprscanimage:true});  

}
pbmenuOpened(){
  this.lppbRecognizer.startCamera();
}
pbmenuClosed(){
  this.zone.run(() => {
    this.pbResults = null;
    this.lppbRecognizer.autonummer = '';
    });

  this.lppbRecognizer.stopCamera();
}

cancelKontrolle(){
  let alert = this.alertCtrl.create();
  alert.setTitle("Kontrolle abbrechen?");
  alert.addButton({
    text: 'Nein',
    handler: (data: any) => {
      //console.log(beweis);
      //beweis.class="";
        //this.stornoEinsatzplan(param, data[0]);
        //this.testCheckboxOpen = false;
    }
  });
  alert.addButton({
    text: 'Ja',
    handler: (data: any) => {
      this.kontrollenData.cancelKontrolle();
      this.navCtrl.setRoot(AccountHomePage);
}
  });
  alert.present();    
  //this.navCtrl.setRoot(AccountHomePage);
}

   ionViewDidEnter() {
    this.menu.swipeEnable(false);
    console.log("did enter");
  }

  ionViewWillLeave() {
    //console.log("will leave");
    if(this.menu.isOpen('pbmenu')){
      //console.log("pb menu is open");

      this.menu.enable(true, 'loggedInMenu');
      this.menu.enable(false, 'pbmenu');
      this.menu.close();  
    }    
    this.menu.enable(true, 'loggedInMenu');

    this.menu.swipeEnable(true);
   }   

   onRefresh(){
    this.events.publish('updateScreen');
    for(var i=0; i<this.kontrollenData.aBeweise.length;i++){
      let tmp = this.kontrollenData.aBeweise[i].filename;
      this.zone.run(() => { 
        this.kontrollenData.aBeweise[i].filename = "";
        console.log("refresh");
      });         
      this.zone.run(() => { 
        this.kontrollenData.aBeweise[i].filename = tmp;
      });         

    }
   }
   onTakePhoto(sBtn){
    if(this.platform.is('cordova')){
      let options: CameraOptions = {
        destinationType: this.camera.DestinationType.FILE_URI,
        encodingType: this.camera.EncodingType.JPEG,
        mediaType: this.camera.MediaType.PICTURE,
        quality: this.userData.imagequality,
        targetWidth: 1000,
        targetHeight: 1000,
        saveToPhotoAlbum:this.userData.storeimageslocally, 
        correctOrientation: true
      }
    
      this.camera.getPicture(options).then((result) => {
              this.addKontrollbeweis(result);
      });      
    }
    //-- Web Upload ----
    /*
    else{
      this.bManualDate = true;
      this.fileElement.nativeElement.click();
    }
    */

   }

onOpenGallery(sBtn){
  let options: CameraOptions = {
    sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
    destinationType: this.camera.DestinationType.FILE_URI,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    quality: this.userData.imagequality,
    targetWidth: 1000,
    targetHeight: 1000,
    saveToPhotoAlbum:false, 
    correctOrientation: true
  }

  this.camera.getPicture(options).then((result) => {
          this.addKontrollbeweis(result);
  });

}

addKontrollbeweis(cameraresult){
  var imgdata = JSON.parse(cameraresult);
  var metadata = JSON.parse(imgdata.json_metadata);
  let bewid = this.common.random(20);
  var iBeweisno = this.kontrollenData.aBeweise.length;
  //let isodate = this.common.exiftoiso(exifObject.DateTimeOriginal);
  let isodate = "";
  if(metadata && metadata.Exif && metadata.Exif.DateTimeOriginal){
    isodate = this.common.exiftoiso(metadata.Exif.DateTimeOriginal);
  }
  //-- Keine Exif DateTime ------
  else{
    isodate = moment().format();
    this.bManualDate = true;
  }          
  this.zone.run(() => {
    this.kontrollenData.aBeweise.push({beweisno:iBeweisno, filename:imgdata.filename , filename_display:imgdata.filename+"?t=" + Date.now(), datetime:moment(isodate).format(), bewid:bewid, class:""});              
  });

}

onAddUE(){
  this.navCtrl.push(UECreatePage, {pp: this.oSelectedPP, fkkontrolle:this.kontrollenData.kont.kontid});  
}
onFinishKontPb(){
  //this.kontrollenData.finishKont();
  Promise.all([
    this.kontrollenData.finishKont()
  ]).then(data => {
    let toast = this.toastCtrl.create({
      message: 'Kontrolle erfolgreich abgeschlossen',
      dismissOnPageChange: false,
      duration: 3000,
      position: 'top',
      //cssClass: 'warning',
      //closeButtonText: 'schliessen',
      //showCloseButton: true
    });
    this.camera.cleanup();
    toast.present()
    .then(data =>{
      //this.navCtrl.popToRoot();
      this.bKontStarted = false; 
      //navigator.camera.cleanup( this.onCameraCleanupSuccess, this.onCameraCleanupFail );                        
      this.navCtrl.setRoot(AccountHomePage, {}, {animate: true, direction: 'back'});
      
    })        
  });

}
onFinishKont(){
  let bError = false;
  //console.log(this.kontrollenData.actkontrolleuecount);
  if((this.oSelectedPP.kontrollprozess == 1) && (this.kontrollenData.aBeweise.length<=0) && (this.kontrollenData.actkontrolleuecount>0)){
          bError = true;
          let toast = this.toastCtrl.create({
            message: 'Allgemeine Kontrollbeweise fehlen, bitte hinzufügen',
            dismissOnPageChange: false,
            duration: 3000,
            position: 'middle',
            cssClass: 'warning',
            closeButtonText: 'schliessen',
            showCloseButton: true
          });
          toast.present()
          .then(data =>{
            return;
          })       
  }
  if(!bError){
    this.bUploading = true;
    if(this.bManualDate){      
      let datetime = this.sDateTimeBeweis.replace("Z", "+01:00");
      this.kontrollenData.manualDateOverride(datetime);
      
    }
    /*
    //-- WEb Upload -----
    const uploadData = new FormData();
    for(let i= 0; i<this.aWebBeweise.length; i++){
      uploadData.append('beweis'+i, this.aWebBeweise[i], this.aWebBeweise[i].name);    
    }
    
    if(!this.platform.is('cordova')){
      this.http.post(encodeURI(this.common.portalurl+"fileuploadkontbewnew_web.php"), uploadData, {})
        .subscribe(event => {
          console.log(event); // handle event here
        });

    }
    */

    Promise.all([
        this.kontrollenData.finishKont(),         
        this.kontrollenData.uploadBeweis()         
      ]).then(data => {
        let success = true;
        let successupload = true;
        console.log(data);
        
        for(let i=0; i<data.length; i++){
          if(i==1){
            let aBew = data[i] as Array<boolean>;
            for(let j=0; j<aBew.length; j++){
              if(aBew[j] != true){
                successupload = false;
              }            
            }//for
          }
          else{
            if(!(data[i])){
              success = false;
            }
          }
        }//for
        this.bUploading = false;
        
        if(success == false){
            let toast = this.toastCtrl.create({
              message: 'Fehler beim abschliessen der Kontrolle',
              dismissOnPageChange: false,
              duration: 3000,
              position: 'middle',
              cssClass: 'warning',
              closeButtonText: 'schliessen',
              showCloseButton: true
            });
            toast.present()
            .then(data =>{

            })        
        }
        else if(successupload == false){

            let toast = this.toastCtrl.create({
              message: 'Es wurden nicht alle Beweise erfolgreich hochgeladen, bitte erneut versuchen.',
              dismissOnPageChange: false,
              duration: 3000,
              position: 'middle',
              cssClass: 'warning',
              closeButtonText: 'schliessen',
              showCloseButton: true
            });
            toast.present()
            .then(data =>{

            })            
        }
        else{

            let toast = this.toastCtrl.create({
              message: 'Kontrolle erfolgreich abgeschlossen',
              dismissOnPageChange: false,
              duration: 3000,
              position: 'top',
              //cssClass: 'warning',
              //closeButtonText: 'schliessen',
              //showCloseButton: true
            });
            this.camera.cleanup();
            toast.present()
            .then(data =>{
              //this.navCtrl.popToRoot();
              this.bKontStarted = false; 
              //navigator.camera.cleanup( this.onCameraCleanupSuccess, this.onCameraCleanupFail );                        
              this.navCtrl.setRoot(AccountHomePage, {}, {animate: true, direction: 'back'});
              
            })             
        }       
      });
  }

}

onDeleteBew(beweis){
      let alert = this.alertCtrl.create();
      beweis.class="wobble";
      alert.setTitle("Beweis löschen");
      alert.addButton({
        text: 'Nein',
        handler: (data: any) => {
          //console.log(beweis);
          beweis.class="";
            //this.stornoEinsatzplan(param, data[0]);
            //this.testCheckboxOpen = false;
        }
      });
      alert.addButton({
        text: 'Ja',
        handler: (data: any) => {
          //console.log(beweis);
          beweis.class="";
          var i = this.kontrollenData.aBeweise.findIndex(i => i.beweisno === beweis.beweisno);
          this.kontrollenData.aBeweise.splice(i,1);         
          //this.stornoEinsatzplan(param, data[0]);
            //this.testCheckboxOpen = false;
        }
      });
      alert.present();  
}
 onFail(message) {
    //alert('Failed because: ' + message);
}

  onCopy(file){
                      console.log("download complete: " + file.toURL());
                      console.log(file);
                      //this.srcPhotoAuto = "hallo";
  }

  onSignup() {
    //this.navCtrl.push(SignupPage);
  }

  async checkPbManual()  {
    if(this.pbid != ""){
      await this.pbData.checkPbById(this.pbid, this.kontrollenData.kont.fkgrund);   
      let tmp = this.pbData.pbResult;
      tmp.forEach(element => {
        element.bShowPbDetail = false;
      });
      this.pbResults = this.pbData.pbResult;
      this.handlePbResult();
      //console.log(this.pbResult);
    }
    return true;
  }
  async scanPb(){
    let config = {
      torchOn: true,
      showTorchButton: true
    };

    this.barcodeScanner.scan(config).then(async (barcodeData) =>  {
    // Success! Barcode data is here
    if(barcodeData.format == "QR_CODE"){

    if(barcodeData.text.includes("parkbewilligung.ch")){
      let sQR = barcodeData.text;
      let aQR = sQR.split("/");
      let strURLIdent = aQR[aQR.length-1]; // Scanned code
      //console.log("hallo");
      //console.log(strURLIdent);
      await this.pbData.checkPbByUrlIdent(strURLIdent, this.kontrollenData.kont.fkgrund);      
      this.pbResults = this.pbData.pbResult;
      this.handlePbResult();
      //console.log(this.pbResult);
    }
    else{
      let toast = this.toastCtrl.create({
        message: 'Ungültiger QR-Code',
        position: 'top',
        cssClass: 'toast-success',
        duration: 2000
      });
      toast.present();             
    }

    }
    else{
          let toast = this.toastCtrl.create({
            message: 'Kein gültiger QR-Code',
            position: 'top',
            cssClass: 'toast-success',
            duration: 2000
          });
          toast.present();     
    }



    }, (err) => {
      // An error occurred
      console.log(err);
    });    
  }

  checkPlate(plate){
    if(plate != ""){
      this.pbData.checkPbByPlate(plate, this.kontrollenData.kont.fkgrund, this.kontrollenData.kont.kontid).then( result => {
        this.vibration.vibrate(100);
        //console.log(this.pbData.pbResult);
        this.pbResults = this.pbData.pbResult;
        this.handlePbResult();
        
      });      
    }
  }

  handlePbResult(){
    let _showFalschparker = 1;
    for(let i = 0; i< this.pbResults.length; i++){
      if(this.pbResults[i].valid == 1){
        _showFalschparker = 0;  
      }
    }
    this.lppbRecognizer.showFalschparkerButton = _showFalschparker;
    
  }
  
  togglePbDetails(pbResult) {
    pbResult.bShowPbDetail = !pbResult.bShowPbDetail;
  }

  onFileChanged(event) {
    const file = event.target.files[0]; 
    
    let bewid = this.common.random(20);
    var iBeweisno = this.kontrollenData.aBeweise.length;
    
    this.aWebBeweise.push(file);

    let isodate = moment().format();
    this.bManualDate = true;

    this.zone.run(() => {
      this.kontrollenData.aBeweise.push({beweisno:iBeweisno, filename:file , filename_display:file, datetime:moment(isodate).format(), bewid:bewid, class:""});              
    });    
    //console.log(file);
  }

}



// WEBPACK FOOTER //
// ./src/pages/kontrollen/kontrollen-create.ts